module.exports = __webpack_public_path__ + "img/buzz-1.f2d24f23.png";